import {
    Button, FormLabel, Paper, Tooltip
} from '@mui/material';
import {
    Switch, TextField, isAtLeast, isAtMost, isEmail
} from '@tsp-ui/core/components';
import { useFieldArray } from 'react-hook-form';

import { ManualLoanEntryFormValues } from '../ManualLoanEntryPage';

import styles from './BorrowersStep.module.scss';
import ManualLoanEntryStep  from './ManualLoanEntryStep';


const borrowerArrayName = 'borrowers';

export default function BorrowersStep() {
    const { fields, append, remove } = useFieldArray<ManualLoanEntryFormValues>({ name: borrowerArrayName });

    const disableAdd = fields.length >= 4;

    return (
        <ManualLoanEntryStep
            className={styles.root}
            secondaryButton={(
                <Tooltip title={disableAdd ? 'Only 4 borrowers are allowed per loan' : ''}>
                    <span>
                        <Button
                            onClick={() => append({})}
                            disabled={disableAdd}
                        >
                            Add borrower
                        </Button>
                    </span>
                </Tooltip>
            )}
        >
            {fields.map((field, index) => (
                <Paper
                    key={field.id}
                    variant="outlined"
                    className={styles.borrowerContainer}
                >
                    <FormLabel className={styles.label}>
                        Borrower {index + 1}
                    </FormLabel>

                    <TextField<ManualLoanEntryFormValues>
                        name={`${borrowerArrayName}.${index}.firstName`}
                        label="First name"
                        size="small"
                        maxLength={100}
                    />

                    <TextField<ManualLoanEntryFormValues>
                        name={`${borrowerArrayName}.${index}.middleName`}
                        label="Middle name"
                        size="small"
                        maxLength={100}
                    />

                    <TextField<ManualLoanEntryFormValues>
                        name={`${borrowerArrayName}.${index}.lastName`}
                        label="Last name"
                        size="small"
                        maxLength={100}
                    />

                    <TextField<ManualLoanEntryFormValues>
                        name={`${borrowerArrayName}.${index}.fico`}
                        label="FICO score"
                        size="small"
                        type="number"
                        rules={{
                            ...isAtLeast(300),
                            ...isAtMost(850)
                        }}
                    />

                    <TextField<ManualLoanEntryFormValues>
                        name={`${borrowerArrayName}.${index}.ssn`}
                        label="SSN"
                        size="small"
                        rules={{
                            pattern: { // TODO add mask to make it look like '111-11-1111'
                                value: /^\d{9}$/,
                                message: 'Please enter a valid SSN'
                            }
                        }}
                    />

                    <TextField<ManualLoanEntryFormValues>
                        name={`${borrowerArrayName}.${index}.email`}
                        label="Email address"
                        size="small"
                        maxLength={100}
                        rules={isEmail}
                    />

                    <div className={styles.switchContainer}>
                        <Switch<ManualLoanEntryFormValues>
                            name={`${borrowerArrayName}.${index}.primaryWageEarner`}
                            label="Primary wage earner"
                        />

                        <Switch<ManualLoanEntryFormValues>
                            name={`${borrowerArrayName}.${index}.firstTimeHomeBuyer`}
                            label="First time home buyer"
                        />
                    </div>

                    <Button
                        className={styles.removeButton}
                        disabled={fields.length === 1}
                        onClick={() => remove(index)}
                    >
                        Remove borrower
                    </Button>
                </Paper>
            ))}
        </ManualLoanEntryStep>
    );
}
